import React from 'react';

import { TileGridBlockData } from 'api/cms';
import { AmpCardsBlock } from 'cms/blocks/Amp/AmpCardsBlock';
import { AmpBlockMappingComponentProps } from 'cms/blocks/BlockMapping';
import { Box } from 'components/Box';
import { H3 } from 'components/Text';

export function AmpTileGridBlock({
  content,
  data: { sections, imageSize },
  blockId,
}: AmpBlockMappingComponentProps<TileGridBlockData>) {
  return (
    <>
      {sections.map((section, index) => (
        <Box mt={index > 0 && 48}>
          <H3>{section.name}</H3>

          <AmpCardsBlock
            content={content}
            blockId={blockId}
            data={{
              imageSize,
              cards: section.tiles.map((tile) => ({
                image: tile.thumbnail,
                headline: tile.heading,
                subheadline: tile.subHeading,
                text: `${tile.description.slice(0, 120)}${
                  tile.description.length > 120 ? '...' : ''
                }`,
              })),
            }}
          />
        </Box>
      ))}
    </>
  );
}
